<article
  class="flex flex-col w-full bg-white border-b border-solid border-b-[color:var(--Neutrals-Light-Gray,#777777)] pb-4 mt-4 max-md:p-3"
  *ngIf="item"
>
  <div class="flex items-start gap-6 max-md:gap-3">
    <!-- Image Container -->
    <div class="w-[199px] h-[149px] max-md:w-[114px] max-md:h-[80px] relative">
      <img
        [src]="item?.part_image_path && item?.part_image_path[0] ? item?.part_image_path[0] : 'https://cdn.builder.io/api/v1/image/assets/TEMP/88f0317dc88579dc26f23e3e9d4d246d40f3ba56'"
        [alt]="item?.table_name"
        class="w-full h-full object-cover rounded-md max-md:rounded-md"
      />
      <div class="absolute top-2 left-2 max-md:top-1 max-md:left-1">
        <input type="checkbox" 
               class="w-4 h-4 rounded-sm border-gray-300"
               [checked]="isSelected"
               (change)="onCheckboxChange($event)"
               [(ngModel)]="isSelected" />
      </div>
      <div
        *ngIf="item?.quality_s"
        class="absolute top-[0px] right-[0px] flex gap-1 items-center px-1 py-0.5 rounded"
        [ngClass]="
          item?.quality_s === 'A' ? 'bg-green-100 text-green-800' :
          item?.quality_s === 'B' ? 'bg-yellow-100 text-yellow-800' :
          item?.quality_s === 'C' ? 'bg-orange-100 text-orange-800' : 'bg-green-100 text-green-800'
        "
      >
      <div>
        <!-- {{ product?.quality_s}} -->
        <svg *ngIf="item?.quality_s" [attr.title]="'Quality grade: ' + item.quality_s" width="20"
          height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"
          class="max-sm:w-5 max-sm:h-5">
          <!-- Background rectangle with rounded corners -->
          <rect width="24" height="24" rx="4" 
            [attr.fill]="
              item?.quality_s === 'A' ? '#01811D' :
              item?.quality_s === 'B' ? '#B8860B' :
              item?.quality_s === 'C' ? '#D35400' : '#01811D'
            " />

          <!-- Dynamic letter inside the SVG -->
          <text [attr.x]="12" [attr.y]="16" text-anchor="middle" font-size="14" font-family="Arial, sans-serif"
            fill="white">
            {{ item.quality_s }}
          </text>
        </svg>
      </div>
        <span class="text-md font-bold max-sm:text-xs"
          [ngClass]="
            item?.quality_s === 'A' ? 'text-green-800' :
            item?.quality_s === 'B' ? 'text-yellow-800' :
            item?.quality_s === 'C' ? 'text-orange-800' : 'text-green-800'
          ">Quality</span>
      </div>
    </div>

    <!-- Product Info -->
    <div class="flex-1 min-w-60 max-md:min-w-0">
      <div class="flex justify-between items-start">
        <div>
          <h3 class="text-base font-bold text-[##88878e] max-md:text-[14px] line-clamp-1">{{ item?.table_name }}</h3>
          <div class="mt-1 text-sm text-zinc-700 max-md:text-[10px] max-md:text-gray-600 max-md:mt-0.5 line-clamp-1">
            <!-- <span class="text-[##88878e] font-medium">{{ item?.table_name }}</span> -->
            <div class="text-[##88878e] font-medium">
              <div class="flex flex-wrap items-center gap-1 text-sm text-gray-700">
                <div class="text-sm">
                  <span *ngIf="item?.part_type === 'Scrap Part'">
                    <span class="text-base text-[#88878e] max-md:text-[14px]">Booking Amount:</span>
                    <span class="text-base font-bold text-Text-Black max-md:text-[12px] ml-1">₹{{ item?.booking_amount | number: '1.0-2' }}</span>
                    <span *ngIf="item?.booking_percent_rule" class="text-xs font-bold text-blue-600 ml-1">
                      ({{ item.booking_percent_rule }}%)
                    </span>
                  </span>
                 
                  
                  <span class="text-sm max-md:text-[10px]" *ngIf="item?.part_type !== 'Scrap Part'">
                  {{ item?.table_name}}
                </span>
                </div>
                <span class="text-gray-400" *ngIf="item?.make">•</span>
                <div class="text-sm max-md:text-[10px]">
                  {{ item?.make}}
                </div>
                <span class="text-gray-400" *ngIf="item?.model">•</span>
  
                <div class="text-sm max-md:text-[10px]">
                  {{ item?.model}}
                </div>
              </div>
            </div>
          </div>
        </div>
        <button class="hidden max-md:block p-1" (click)="openMoreOptionsModal()">
          <svg width="16" height="16" viewBox="0 0 16 16" class="rotate-90" fill="none">
            <circle cx="2" cy="8" r="2" fill="#1F2937"/>
            <circle cx="8" cy="8" r="2" fill="#1F2937"/>
            <circle cx="14" cy="8" r="2" fill="#1F2937"/>
          </svg>
        </button>
      </div>

      <!-- Price Section -->
      <div class="flex items-center gap-2 mt-2 max-md:mt-1">
        <span class="font-bold text-base max-md:text-[14px]" *ngIf="item?.part_type === 'Scrap Part'"> <span class="text-neutral-500 font-medium max-md:text-[10px]">Total Price :</span>₹{{ (item?.discounted_price ? item?.discounted_price * item?.total_quantity :  item?.price_s * item?.total_quantity ) | number: '1.0-2' }} for {{ item?.total_quantity }} {{ item?.unit_of_measurement }} Kg</span>
<span *ngIf="item?.part_type !== 'Scrap Part'">
        <span class="font-bold text-base max-md:text-[14px]">₹{{ item?.discounted_price ? item?.discounted_price : item?.price_s }}</span>
        <span
 *ngIf="item?.discounted_price &&
              item?.price_s &&
              item?.discount_percentage > 0
            "
  class="text-neutral-500 line-through text-base max-md:text-[12px]"
>
  ₹{{ item?.price_s }}
</span>
        <span *ngIf="item?.discount_percentage > 0" class="px-1.5 py-1 text-xs bg-emerald-800 text-white rounded-[40px] max-md:bg-emerald-800 max-md:text-white-800 max-md:text-[10px] max-md:py-0.5">
          {{ item?.discount_percentage  }}% Off
        </span>
      </span>
        <!-- <span class="px-1.5 py-1 text-xs bg-emerald-800 text-white rounded-[40px] max-md:bg-emerald-800 max-md:text-white-800 max-md:text-[10px] max-md:py-0.5">
          {{ item?.tax_s }}%
        </span> -->
      </div>

      <!-- Seller Info -->
      <div class="flex gap-1 mt-2 text-sm max-md:mt-1">
        <span class="text-neutral-500 max-md:text-[12px]">Sold by:</span>
        <span class="font-bold text-black max-md:text-[12px] max-md:font-medium">{{ item?.seller_name }}</span>
      </div>

      <!-- Action Buttons -->
      <div class="flex gap-4 sm:gap-6 mt-2 text-xs sm:text-sm font-bold text-blue-500">
        <button (click)="confirmRemove(item)" class="rounded-xl cursor-pointer hover:text-blue-700">Remove</button>
        <button (click)="moveToWishlistItem(item)" class="rounded-xl cursor-pointer hover:text-blue-700" [class.text-gray-300]="!isUserLoggedIn" [disabled]="!isUserLoggedIn">Move to wishlist</button>
      </div>
    </div>

    <!-- Delivery Section - Desktop Only -->
    <div class="w-[189px] max-md:hidden relative">
      <!-- Dropdown toggle box -->
      <div
        class="flex flex-col px-3 py-2 rounded border"
        [ngClass]="{
          'bg-slate-50 cursor-pointer': !isStorePickupLocked,
          'bg-neutral-200 cursor-not-allowed text-neutral-500': isStorePickupLocked
        }"
        (click)="toggleDropdown()"
      >
        <div
          class="flex gap-2 items-center text-sm font-bold"
          [ngClass]="isStorePickupLocked ? 'text-neutral-500' : 'text-blue-500'"
        >
            <svg *ngIf="selectedOption === 'Home Delivery'" width="19" height="14" viewBox="0 0 19 14" fill="none" xmlns="http://www.w3.org/2000/svg" class="w-5 h-5">
              <path d="M10.832 10.8334V4.16671M10.832 10.8334H12.4987M10.832 10.8334H7.91536M3.33203 10.8334H4.58203M10.832 4.16671V1.66671C10.832 1.20647 10.4589 0.833374 9.9987 0.833374H3.33203C2.87179 0.833374 2.4987 1.20647 2.4987 1.66671V3.33337M10.832 4.16671H14.3083C14.7504 4.16671 15.1743 4.3423 15.4869 4.65486L17.0105 6.17855C17.3231 6.49111 17.4987 6.91504 17.4987 7.35706V10C17.4987 10.4603 17.1256 10.8334 16.6654 10.8334H15.832M7.91536 10.8334C7.91536 11.7538 7.16917 12.5 6.2487 12.5C5.32822 12.5 4.58203 11.7538 4.58203 10.8334M7.91536 10.8334C7.91536 9.9129 7.16917 9.16671 6.2487 9.16671C5.32822 9.16671 4.58203 9.9129 4.58203 10.8334M15.832 10.8334C15.832 11.7538 15.0858 12.5 14.1654 12.5C13.2449 12.5 12.4987 11.7538 12.4987 10.8334M15.832 10.8334C15.832 9.9129 15.0858 9.16671 14.1654 9.16671C13.2449 9.16671 12.4987 9.9129 12.4987 10.8334M2.4987 3.33337H5.83203M2.4987 3.33337H0.832031M7.4987 5.83337H2.4987M2.91536 8.33337H1.66536" [attr.stroke]="selectedOption === 'Home Delivery' ? '#307FE1' : 'black'" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
            <svg *ngIf="selectedOption === 'Store Pickup'"  width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg" class="w-5 h-5">
              <path d="M14.4189 7.26722V13.3334C14.4189 14.7141 13.251 15.8334 11.8103 15.8334H10.5059M14.4189 7.26722C14.7511 7.10329 15.0833 6.85535 15.3671 6.61151C15.8804 6.17035 15.959 5.4519 15.6507 4.8609L14.2704 2.21534C13.8285 1.36838 12.9252 0.833374 11.9371 0.833374H4.72693C3.73883 0.833374 2.83554 1.36838 2.39365 2.21534L1.01337 4.8609C0.705028 5.4519 0.783708 6.17035 1.29701 6.61151C1.58072 6.85535 1.91292 7.10329 2.24512 7.26722M14.4189 7.26722C14.1336 7.40802 13.8371 7.50004 13.5494 7.50004C11.8103 7.50004 10.9407 5.83337 10.9407 5.83337C10.9407 5.83337 10.0711 7.50004 8.33203 7.50004C6.59291 7.50004 5.72335 5.83337 5.72335 5.83337C5.72335 5.83337 4.85379 7.50004 3.11468 7.50004C2.82697 7.50004 2.53044 7.40802 2.24512 7.26722M2.24512 7.26722V13.3334C2.24512 14.7141 3.41306 15.8334 4.85379 15.8334H6.15813M6.15813 15.8334V11.6667C6.15813 11.2065 6.54745 10.8334 7.02769 10.8334H9.63637C10.1166 10.8334 10.5059 11.2065 10.5059 11.6667V15.8334M6.15813 15.8334H10.5059" [attr.stroke]="dropdownOpen ? '#307FE1' : (isStorePickupLocked ? '#777777' : (selectedOption === 'Store Pickup' ? '#307FE1' : 'black'))" stroke-width="1.66667" stroke-linejoin="round"/>
            </svg>
          <span class="flex-1">{{ selectedOption }}</span>
          <img
            src="https://cdn.builder.io/api/v1/image/assets/TEMP/88f0317dc88579dc26f23e3e9d4d246d40f3ba56"
            class="w-4 h-4"
          />
        </div>
        <p
          class="mt-1 text-xs"
          [ngClass]="isStorePickupLocked ? 'text-neutral-400' : 'text-neutral-500'"
        >
          {{ selectedOption === 'Home Delivery' ? 'Get Delivery by' : 'Pickup after' }}
          <span
            class="font-bold"
            [ngClass]="isStorePickupLocked ? 'text-neutral-500' : 'text-black'"
            >{{ selectedOption === 'Home Delivery' ? getDeliveryDate() : getPickupDate() }}</span
          >
        </p>
      </div>
    
      <!-- Dropdown Options -->
      <div
        *ngIf="dropdownOpen"
        class="absolute z-10 w-full mt-2 bg-white rounded border shadow-md"
      >
        <div
          *ngIf="selectedOption !== 'Store Pickup'"
          class="px-3 py-2"
          [ngClass]="{
            'cursor-pointer text-black': !isStorePickupLocked,
            'cursor-not-allowed text-neutral-400': isStorePickupLocked
          }"
          (click)="selectOption('Store Pickup')"
        >
          <div class="flex items-center gap-2 text-sm">
            <img [src]="getIcon('Store Pickup')" class="w-5 h-5" />
            Store Pickup
          </div>
          <p class="text-xs text-neutral-500 mt-1">
            Pickup after <span class="font-bold text-black">{{ getPickupDate() }}</span>
          </p>
        </div>
        <div
          *ngIf="selectedOption !== 'Home Delivery'"
          class="px-3 py-2"
          [ngClass]="{
            'cursor-pointer text-black': !isStorePickupLocked,
            'cursor-not-allowed text-neutral-400': isStorePickupLocked
          }"
          (click)="selectOption('Home Delivery')"
        >
          <div class="flex items-center gap-2 text-sm">
            <img [src]="getIcon('Home Delivery')" class="w-5 h-5" />
            Home Delivery
          </div>
          <p class="text-xs text-neutral-500 mt-1">
            Get Delivery by <span class="font-bold text-black">{{ getDeliveryDate() }}</span>
          </p>
        </div>
      </div>
    </div>
    
  </div>

  <!-- Delivery Options - Mobile Only -->
  <div class="hidden max-md:block"> 
    <!-- Expandable Container -->
    <div
      class="w-full mt-3 border rounded-lg overflow-hidden"
      [ngClass]="{
        'bg-blue-50 border-blue-200': !isStorePickupLocked,
        'bg-neutral-100 border-neutral-300': isStorePickupLocked
      }"
    >
      <!-- Selected Option Header -->
      <button
        (click)="toggle()"
        class="flex items-center justify-between w-full p-2.5"
        [disabled]="isStorePickupLocked"
        [ngClass]="{
          'cursor-pointer': !isStorePickupLocked,
          'cursor-not-allowed': isStorePickupLocked
        }"
      >
        <div class="flex items-center gap-2">
          <img [src]="getIcon(selectedOption)" class="w-5 h-5" />
          <div class="text-left">
            <p
              class="text-[14px] font-medium"
              [ngClass]="isStorePickupLocked ? 'text-neutral-500' : 'text-blue-700'"
            >
              {{ selectedOption }}
              <span class="text-[12px]" [ngClass]="isStorePickupLocked ? 'text-neutral-400' : 'text-gray-600'">
                ( {{ selectedOption === 'Home Delivery' ? 'Get Delivery by' : 'Pickup after' }}
              </span>
              <span
                class="font-medium"
                [ngClass]=" 'text-black'"
              >
                {{ selectedOption === 'Home Delivery' ? getDeliveryDate() : getPickupDate() }})
              </span>
            </p>
          </div>
        </div>
        <svg
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="none"
          [ngClass]="{
            'text-blue-700': !isStorePickupLocked,
            'text-neutral-400': isStorePickupLocked,
            'rotate-180': !isStorePickupLocked && isExpanded
          }"
        >
          <path d="M5 7.5L10 12.5L15 7.5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      </button>

      <!-- Separator Div -->
      <div *ngIf="isExpanded && !isStorePickupLocked" class="border-t border"></div>

      <!-- Expanded Options -->
      <div *ngIf="isExpanded && !isStorePickupLocked" class="bg-white">
        <!-- Home Delivery Option - Show only if Store Pickup is selected -->
        <div *ngIf="selectedOption === 'Store Pickup'" class="cursor-pointer p-2.5" (click)="selectOption('Home Delivery'); toggle()">
          <div class="flex items-center gap-2">
            <img [src]="getIcon('Home Delivery')" class="w-5 h-5" />
            <div class="text-left">
              <p class="text-[14px] font-medium text-gray-900">
                Home Delivery <span class="text-[12px] text-gray-600">
                  (Get Delivery by <span class="font-medium">{{ getDeliveryDate() }}</span>)
                </span>
              </p>
              
            </div>
          </div>
        </div>
        
        <!-- Store Pickup Option - Show only if Home Delivery is selected -->
        <div *ngIf="selectedOption === 'Home Delivery'" class="cursor-pointer p-2.5" (click)="selectOption('Store Pickup'); toggle()">
          <div class="flex items-center gap-2">
            <img [src]="getIcon('Store Pickup')" class="w-5 h-5" />
            <div class="text-left">
              <p class="text-[14px] font-medium text-blue-700">
                Store Pickup <span class="text-[12px] text-gray-600">
                  (Pickup after <span class="font-medium">{{ getPickupDate() }}</span>)
                </span>
              </p>
              
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</article>

<!-- More Options Bottom Sheet Modal - Mobile Only -->
<div 
  *ngIf="showMoreOptionsModal" 
  class="fixed inset-0 z-50 flex items-end bg-black bg-opacity-50 backdrop-blur-sm transition-all duration-300 ease-in-out max-md:flex md:hidden"
  (click)="closeMoreOptionsModal()"
>
  <div 
    class="mobile-popup-slide-up w-full bg-white rounded-t-lg shadow-2xl flex flex-col max-h-[80vh] overflow-hidden"
    (click)="$event.stopPropagation()"
  >
    <!-- Header -->
    <div class="w-full px-4 py-3 bg-white border-b border-gray-300 flex justify-between items-center">
      <div class="text-lg font-bold text-[#0A0A5F]">
        More Options
      </div>
      <button 
        type="button" 
        class="p-1 rounded hover:bg-gray-100 transition-colors"
        (click)="closeMoreOptionsModal()"
      >
        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M15 5L5 15M5 5L15 15" stroke="#1F2937" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      </button>
    </div>

    <!-- Body with Radio Options -->
    <div class="flex-1 px-4 py-4 bg-white flex flex-col gap-4">
      <!-- Delete Option -->
      <label class="flex items-center gap-3 cursor-pointer py-2">
        <input 
          type="radio" 
          name="actionOption" 
          value="delete"
          [checked]="selectedAction === 'delete'"
          (change)="onActionChange('delete')"
          class="w-5 h-5 text-blue-600 border-gray-300 focus:ring-blue-500 focus:ring-2"
        />
        <span class="text-base font-medium text-gray-900">Delete</span>
      </label>

      <!-- Move to wishlist Option -->
      <label class="flex items-center border-t border-gray-300 gap-3 cursor-pointer py-2">
        <input 
          type="radio" 
          name="actionOption" 
          value="wishlist"
          [checked]="selectedAction === 'wishlist'"
          (change)="onActionChange('wishlist')"
          [disabled]="!isUserLoggedIn"
          class="w-5 h-5 text-blue-600 border-gray-300 focus:ring-blue-500 focus:ring-2 disabled:opacity-50 disabled:cursor-not-allowed"
        />
        <span class="text-base font-medium" [ngClass]="isUserLoggedIn ? 'text-gray-900' : 'text-gray-400'">Move to wishlist</span>
      </label>
    </div>

    <!-- Footer with Action Buttons -->
    <div class="w-full px-4 py-4 bg-white border-t border-gray-200 flex gap-3">
      <button 
        type="button"
        class="flex-1 px-4 py-3 text-base font-bold text-blue-600 bg-white border-2 border-blue-600 rounded-lg hover:bg-blue-50 transition-colors"
        (click)="closeMoreOptionsModal()"
      >
        Cancel
      </button>
      <button 
        type="button"
        class="flex-1 px-4 py-3 text-base font-bold text-white bg-[#0A0A5F] rounded-lg hover:bg-[#0A0A5F]/90 transition-colors"
        (click)="handleContinue()"
        [disabled]="selectedAction === 'wishlist' && !isUserLoggedIn"
        [ngClass]="{'opacity-50 cursor-not-allowed': selectedAction === 'wishlist' && !isUserLoggedIn}"
      >
        Continue
      </button>
    </div>
  </div>
</div>

<!-- Confirmation Modal for Removing Cart Item -->
<div *ngIf="showConfirmDeleteModal" class="fixed inset-0 z-[110] flex items-center justify-center p-4">
  <div class="fixed inset-0 bg-black/50" (click)="cancelDelete()"></div>
  <div class="relative bg-white rounded-xl shadow-2xl max-w-sm w-full mx-auto z-10 overflow-hidden" (click)="$event.stopPropagation()">
    <div class="px-6 pt-6 pb-2">
      <h3 class="text-lg font-bold text-gray-900">Remove Item</h3>
    </div>
    <div class="px-6 pb-5">
      <p class="text-sm text-gray-600">Are you sure you want to remove this item from your cart?</p>
    </div>
    <div class="px-6 pb-6 flex gap-3">
      <button type="button" (click)="executeDelete()" class="flex-1 px-4 py-2 bg-red-600 hover:bg-red-700 text-white font-semibold text-sm rounded-lg transition-colors cursor-pointer">
        Yes, Remove
      </button>
      <button type="button" (click)="cancelDelete()" class="flex-1 px-4 py-2 border border-gray-300 hover:bg-gray-50 text-gray-700 font-semibold text-sm rounded-lg transition-colors cursor-pointer">
        Cancel
      </button>
    </div>
  </div>
</div>
